// src/pages/Profile.tsx
import * as React from "react";

const ManageListing: React.FC = () => {
  return (
    <div>
      <h1 className="text-4xl font-bold">ManageListing</h1>
      <p className="mt-4">Update your profile information here.</p>
    </div>
  );
};

export default ManageListing;
